import { DropShadowFilter } from "pixi-filters";
import { Container, Point, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { StringFormatExtention } from "../../../../../extensions/StringFormatExtention";
import { HBox } from "../../../common/components/ui/HBox";
import { BuildingRankUpResourcePackage } from "../resources/BuildingRankUpResourcePackage";
import { BuildingRightsType } from "../../../../networking/data/responses/user/BuildingRightsType";
import { PiggyMultiplier } from "../../../common/components/PiggyMultiplier";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";

export class BuildingRankUpRewardComponent extends Container {
    public constructor(
        coinCount: number,
        piggyMultiplier: number,
        rankUpResources: BuildingRankUpResourcePackage,
        commonResources: CommonResourcesPackage,
        role: BuildingRightsType
    ) {
        super();
        const headerText = new Text(`THE REWARD IS`, new RewardCountTextStyle());
        headerText.style.fontSize = 64;
        headerText.style.letterSpacing = 2.65;
        this.addChild(headerText);
        const hBox = new HBox(19);
        const rewardCountText = new Text(StringFormatExtention.formatWithComma(coinCount), new RewardCountTextStyle());
        hBox.addChild(rewardCountText);
        const icon = new Sprite(rankUpResources.assets_views_building_rank_up_coin_png);
        icon.width = 100;
        icon.height = 100;
        icon.y = 51.5;
        hBox.addChild(icon);
        hBox.position.set(headerText.x + headerText.width * 0.5 - hBox.width * 0.5, 131);
        this.addChild(hBox);
        if (role != BuildingRightsType.RENTER && (piggyMultiplier != undefined && piggyMultiplier > 0)) {
            const light = new Sprite(rankUpResources.assets_views_building_rank_up_violet_light_png);
            light.position.set(hBox.x + hBox.width * 0.5 - light.width * 0.5, 298.5);
            this.addChild(light);
            const hBox2 = new HBox(23);
            const piggyPercentText = new Text(`+${piggyMultiplier ?? 0}%`, new RewardCountTextStyle());
            hBox2.addChild(piggyPercentText);
            const piggyIcon = new PiggyMultiplier(commonResources);
            piggyIcon.y = 56;
            piggyIcon.scale.set(1.2);
            hBox2.addChild(piggyIcon);
            hBox2.position.set(light.x + light.width * 0.5 - hBox2.width * 0.5, 293.5);
            this.addChild(hBox2);
        }
        const orangeGlow = new DropShadowFilter({
            offset: new Point(0, 0),
            blur: 20,
            color: 0xFF6E0E,
            quality: 4.5,
            alpha: 1,
            pixelSize: 1
        });
        hBox.filters = [orangeGlow];
    }
}

class RewardCountTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ffffff",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 108,
            lineHeight: 216.4,
        }));
    }
}
